import * as React from 'react'
import { WithI18n, withI18n } from 'src/core/i18n/withI18n'
import { compose } from 'redux'
import { WithStyles, Theme, createStyles, withStyles, Typography } from '@material-ui/core'
import { IProduct } from 'src/type/product'
import ProductCard from 'src/shared/Product/ProductCard'
import {css} from 'src/conf/style'

const styles = (t: Theme) => createStyles({
    root: {
        display: 'flex',
        flexDirection: 'row',
        width: '100%',
        [t.breakpoints.down('md')]: {
          flexDirection: 'column'
        }
    },
    productCardWpr: {
        margin: t.spacing.unit,
        width: `calc(25% - ${t.spacing.unit * 2}px)`,
        [t.breakpoints.down('md')]: {
            width: '100%'
        }
    },
    alertEmpty: {
        ...css.flexFullCenter,
        width: '100%'
    }
});

interface IProps extends WithI18n,
  WithStyles<typeof styles>{
    entities: IProduct[];
    shouldHidden: boolean;
}

class ProductsFlow extends React.Component<IProps, {}> {

  render() {
    const {t, classes, entities, shouldHidden} = this.props
    return (
        <div className={classes.root}>
            {entities && !shouldHidden &&
                entities.map(n => {
                    return (
                        <div key={`product-wpr-${n.id}`} className={classes.productCardWpr}>
                            <ProductCard key={`product-card-${n.id}`} entity={n}/>
                        </div>
                    )
                })
            }
            {((entities && entities.length === 0) || shouldHidden) &&
                <div className={classes.alertEmpty}>
                    <Typography variant="body2" align="center">{t.products_no_post_in_categories}</Typography>
                </div>
            }
        </div>
    )
  }

}

export default compose(
    withI18n,
    withStyles(styles)
)(ProductsFlow)



// WEBPACK FOOTER //
// ./src/page/Consumer/Products/ProductsFlow.tsx